/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './survey-input-type.reducer';

export const SurveyInputTypeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const surveyInputTypeEntity = useAppSelector(state => state.surveyInputType.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="surveyInputTypeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.surveyInputType.detail.title">SurveyInputType</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.surveyInputType.id">Id</Translate>
            </span>
          </dt>
          <dd>{surveyInputTypeEntity.id}</dd>
          <dt>
            <span id="inputTypeName">
              <Translate contentKey="tinyMedicRestApp.surveyInputType.inputTypeName">Input Type Name</Translate>
            </span>
          </dt>
          <dd>{surveyInputTypeEntity.inputTypeName}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.surveyInputType.active">Active</Translate>
            </span>
          </dt>
          <dd>{surveyInputTypeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.surveyInputType.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{surveyInputTypeEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.surveyInputType.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{surveyInputTypeEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.surveyInputType.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{surveyInputTypeEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.surveyInputType.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{surveyInputTypeEntity.timestampentry}</dd>
        </dl>
        <Button tag={Link} to="/survey-input-type" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/survey-input-type/${surveyInputTypeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SurveyInputTypeDetail;
